import React from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import { BsFillQuestionCircleFill } from "react-icons/bs";
import { jsonKeyMapping } from "../../Config/Constants";
import { FAQ } from "../../Models/Faq";

type Props = {
  faqContentList: FAQ[];
};

export default function FaqComponent({ faqContentList }: Props) {
  return (
    <OverlayTrigger
      trigger="click"
      placement="auto-start"
      rootClose
      overlay={
        <Popover>
          {faqContentList.map((faq, index) => {
            return (
              <div key={index}>
                <Popover.Header as="h4" className="faq-header">
                  {faq[jsonKeyMapping.FAQ_HEADER]}
                </Popover.Header>
                <Popover.Body
                  dangerouslySetInnerHTML={{
                    __html: faq[jsonKeyMapping.FAQ_TEXT],
                  }}
                ></Popover.Body>
              </div>
            );
          })}
        </Popover>
      }
    >
      <button className="preview-faq-btn">
        <svg
          width="29"
          height="29"
          viewBox="0 0 29 29"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.1034 11.2592C11.579 10.25 12.8623 9.52699 14.3707 9.52699C16.284 9.52699 17.8351 10.6903 17.8351 12.1253C17.8351 13.3374 16.7286 14.3556 15.2318 14.6427C14.762 14.7329 14.3707 15.1114 14.3707 15.5897M14.3706 18.1881H14.3793M22.1656 13.8575C22.1656 18.1626 18.6757 21.6525 14.3706 21.6525C10.0656 21.6525 6.57568 18.1626 6.57568 13.8575C6.57568 9.55248 10.0656 6.06256 14.3706 6.06256C18.6757 6.06256 22.1656 9.55248 22.1656 13.8575Z"
            stroke="#16283D"
            stroke-width="1.38577"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <span>FAQ</span>
      </button>
    </OverlayTrigger>
  );
}
